import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(({ tokens }) => ({
  icon24: {
    '& > div': {
      height: 24,
    },
    height: 24,
    '& img': {
      height: 24,
      width: 'auto',
    },
  },
  icon32: {
    '& > div': {
      height: 32,
    },
    height: 32,
    '& img': {
      height: 32,
      width: 'auto',
    },
  },
  icon72: {
    '& > div': {
      height: 32,
    },
    height: 72,
    '& img': {
      height: 72,
      width: 'auto',
    },
  },
  icon80: {
    '& > div': {
      height: 32,
    },
    '& img': {
      height: 80,
      width: 'auto',
    },
    height: 80,
  },

  sidebarErrorLogo: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: tokens.spacing['4'],
  },

  sidebarLogo: {
    '& > div': {
      display: 'flex',
      alignItems: 'center',
      maxHeight: 40,
    },
    maxHeight: 40,
    '& img': {
      maxHeight: 40,
      maxWidth: '100%',
      width: 'inherit',
    },
  },
}));
